import { render, staticRenderFns } from "./LoadingData.vue?vue&type=template&id=bbee0f72&"
import script from "./LoadingData.vue?vue&type=script&lang=js&"
export * from "./LoadingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoadingData.vue"
export default component.exports